// extracted by mini-css-extract-plugin
export var container = "_1k-0";
export var disabled = "_1k-4";
export var fullWidth = "_1k-3";
export var lined = "_1k-1";
export var selected = "_1k-5";
export var tab = "_1k-2";